import * as React from "react";
import ContentSlider, { IContentSliderProps } from "~/components/content-slider/content-slider";

export interface IContentSliderViewProps {
    contextModel: IContentSliderProps;
}

class ContentSliderView extends React.PureComponent<IContentSliderViewProps> {
    public render() {
        return <ContentSlider {...this.props.contextModel} />;
    }
}

export default ContentSliderView;
